import AddressConfirmation from './AddressConfirmation';

export default AddressConfirmation;
